export type PageCondition = 'visible' | 'online';

function isPageReady(conditions: PageCondition[]) {
  return conditions.every((condition) =>
    condition === 'visible'
      ? document.visibilityState === 'visible'
      : navigator.onLine
  );
}

/**
 * Resolves once the page is in view and/or the device has a network
 * (immediately when it already is), or when aborted. For retries: those made
 * offline or in a hidden tab fail or are wasted, and use up the attempts.
 */
export function waitForPage(
  conditions: PageCondition[],
  signal?: AbortSignal
): Promise<void> {
  if (signal?.aborted || isPageReady(conditions)) return Promise.resolve();
  return new Promise((resolve) => {
    const done = () => {
      document.removeEventListener('visibilitychange', onChange);
      window.removeEventListener('online', onChange);
      signal?.removeEventListener('abort', done);
      resolve();
    };
    const onChange = () => {
      if (isPageReady(conditions)) done();
    };
    document.addEventListener('visibilitychange', onChange);
    window.addEventListener('online', onChange);
    signal?.addEventListener('abort', done);
  });
}
